var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgParcelNavArrow = function SvgParcelNavArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 110,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56.897 44.979c3.928 3.858 3.999 10.165.159 14.11L25.504 91.504c-6.37 6.545-17.46 1.827-17.16-7.302l2.007-61.429c.284-8.704 10.787-12.91 17.001-6.808z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.069 46.11a8 8 0 0 1 .12 11.454L13.952 87.68C8.865 92.747.195 89.066.307 81.887l.907-58.131c.11-6.98 8.478-10.481 13.525-5.66z"
  })));
};
export default SvgParcelNavArrow;